"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = require("@bringg/types");
var lodash_1 = require("lodash");
var Entity_1 = __importStar(require("../../Core/Entity"));
var ReasonToReassignTasksEntity = /** @class */ (function (_super) {
    __extends(ReasonToReassignTasksEntity, _super);
    function ReasonToReassignTasksEntity(session) {
        var _this = _super.call(this, {
            session: session,
            entityName: 'reason_to_reassign_tasks',
            routes: [Entity_1.BaseRoutes.GetAll]
        }) || this;
        _this.items = [];
        _this.isAllLoaded = false;
        _this.isGroupLoaded = {};
        _this.itemsByGroup = {};
        return _this;
    }
    ReasonToReassignTasksEntity.prototype.storeGroup = function (groupItems, group) {
        this.itemsByGroup[group] = groupItems;
        this.isGroupLoaded[group] = true;
    };
    ReasonToReassignTasksEntity.prototype.storeAllItems = function (items) {
        var _this = this;
        this.items = items;
        this.isAllLoaded = true;
        Object.entries((0, lodash_1.groupBy)(items, 'target_entity_type')).forEach(function (_a) {
            var _b = __read(_a, 2), group = _b[0], items = _b[1];
            var groupName = types_1.OrderReassignedEntityType[group];
            if (groupName) {
                _this.storeGroup(items, types_1.OrderReassignedEntityType[groupName]);
            }
        });
    };
    ReasonToReassignTasksEntity.prototype.loadAll = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.service.getAll()];
                    case 1:
                        response = _a.sent();
                        this.storeAllItems(response.reasons_to_reassign_tasks);
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @deprecated use loadGroup / getGroup instead
     */
    ReasonToReassignTasksEntity.prototype.getAll = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!this.isAllLoaded) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.loadAll()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.items];
                }
            });
        });
    };
    ReasonToReassignTasksEntity.prototype.loadGroup = function (group) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!this.isGroupLoaded[group]) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.service.getAll({ target_entity_type: group })];
                    case 1:
                        response = _a.sent();
                        this.storeGroup(response.reasons_to_reassign_tasks, group);
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.getGroup(group)];
                }
            });
        });
    };
    ReasonToReassignTasksEntity.prototype.getGroup = function (group) {
        return this.itemsByGroup[group] || [];
    };
    return ReasonToReassignTasksEntity;
}(Entity_1.default));
exports.default = ReasonToReassignTasksEntity;
//# sourceMappingURL=ReasonToReassignTasksEntity.js.map